import { EMAIL_SUCCESS_MESSAGE, REMOVE_MESSAGE } from './types';

export const emailMessage = () => {
    return (dispatch) => {
        dispatch({
            type: EMAIL_SUCCESS_MESSAGE
        });
        setTimeout(() => {
            dispatch(removeMessage());
        }, 5000);
    };
};

export const removeMessage = () => {
    return (dispatch) => {
        dispatch({
            type: REMOVE_MESSAGE
        });
    };
};
